import { render, staticRenderFns } from "./IcoChevronDown.vue?vue&type=template&id=5bec0c3c"
import script from "./IcoChevronDown.vue?vue&type=script&lang=js"
export * from "./IcoChevronDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports